export default __webpack_public_path__ + "static/media/HomeBanner1.5e15477b.jpg";